export const CHALLENGE_MFA_SETUP_ISSUED = '@auth/CHALLENGE_MFA_SETUP_ISSUED';
export const CHALLENGE_MFA_SETUP_SUBMITTED = '@auth/CHALLENGE_MFA_SETUP_SUBMITTED';
export const CHALLENGE_MFA_SETUP_ACCEPTED = '@auth/CHALLENGE_MFA_SETUP_ACCEPTED';
export const CHALLENGE_MFA_SETUP_REJECTED = '@auth/CHALLENGE_MFA_SETUP_REJECTED';

export const issueChallengeMfaSetup = () => ({
    type: CHALLENGE_MFA_SETUP_ISSUED,
    payload: {},
});

export const submitChallengeMfaSetup = () => ({
    type: CHALLENGE_MFA_SETUP_SUBMITTED,
    payload: {},
});

export const acceptChallengeMfaSetup = ({ user, secretCode }) => ({
    type: CHALLENGE_MFA_SETUP_ACCEPTED,
    payload: { user, secretCode },
});

export const rejectChallengeMfaSetup = ({ code }) => ({
    type: CHALLENGE_MFA_SETUP_REJECTED,
    payload: { code },
});
